/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OutgoingPaymentState = 'CREATED' | 'READY' | 'IMPORTED' | 'SEND' | 'PAID' | 'STORNO' | 'DONT_PAY' | 'RETURNED';

export const OutgoingPaymentState = {
    CREATED: 'CREATED' as OutgoingPaymentState,
    READY: 'READY' as OutgoingPaymentState,
    IMPORTED: 'IMPORTED' as OutgoingPaymentState,
    SEND: 'SEND' as OutgoingPaymentState,
    PAID: 'PAID' as OutgoingPaymentState,
    STORNO: 'STORNO' as OutgoingPaymentState,
    DONT_PAY: 'DONT_PAY' as OutgoingPaymentState,
    RETURNED: 'RETURNED' as OutgoingPaymentState
};

